import { Button } from "./ui/button";
import { Heart, Menu, X } from "lucide-react";
import { useState } from "react";
const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navItems = [{
    name: "Reports",
    href: "#reports"
  }, {
    name: "Courses",
    href: "#courses"
  }, {
    name: "Call Consultation",
    href: "#consultation"
  }, {
    name: "Ask Our Astrologer",
    href: "#ask"
  }, {
    name: "Gemstone",
    href: "#gemstone"
  }, {
    name: "Free Calculator",
    href: "#calculator"
  }, {
    name: "Horoscope",
    href: "#horoscope"
  }, {
    name: "About",
    href: "#about"
  }];
  return <header className="bg-primary text-primary-foreground shadow-lg sticky top-0 z-50">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <div className="flex items-center space-x-2">
            <Heart className="h-8 w-8 text-love-pink" />
            <div className="text-xl font-bold">Acharya Lav Bhushan</div>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-6">
            {navItems.map(item => <a key={item.name} href={item.href} className="text-sm hover:text-love-pink transition-colors duration-300">
                {item.name}
              </a>)}
          </nav>

          {/* CTA Button */}
          <div className="hidden lg:block">
            <Button variant="love" size="sm">
              Course Login
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button className="lg:hidden p-2" onClick={() => setIsMenuOpen(!isMenuOpen)}>
            {isMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && <nav className="lg:hidden py-4 border-t border-primary-foreground/10">
            {navItems.map(item => <a key={item.name} href={item.href} className="block py-2 text-sm hover:text-love-pink transition-colors duration-300" onClick={() => setIsMenuOpen(false)}>
                {item.name}
              </a>)}
            <div className="mt-4">
              <Button variant="love" size="sm" className="w-full">
                Course Login
              </Button>
            </div>
          </nav>}
      </div>
    </header>;
};
export default Header;